import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      dashboard: {
         adamedExpert: {
            authenticate: {
               emailAddress: 'Adres e-mail',
               info: 'Zaloguj się do serwisu Adamed Expert i sprawdź, co nowego.',
               invalidCredentialsFault: 'Niepoprawne dane logowania',
               logIn: 'Zaloguj się do Adamed Expert',
               password: 'Hasło',
               passwordPlaceholder: 'Wprowadź hasło do portalu Adamed Expert...',
               rememberMe: 'Zapamiętaj mnie',
            },
            button: 'ADAMED EXPERT',
            externalSystemBusinessFault: 'Treść komunikatu Adamed Expert: {{messageFromAdamedExpert}}',
            loading: 'Proszę czekać, trwa przekierowanie do Adamed Expert',
         },
         advertisement: {
            contentFetchFailed: 'Nie udało się pobrać treści',
         },
         cards: {
            confirmed: 'Zatwierdzone',
            confirmedCount: 'Liczba zatwierdzonych',
            currentWeek: 'Ten tydz.',
            dataUpdated: 'Dane aktualne na: <date />',
            gifDecisions: 'Powiadomienia GIF',
            news: 'Nowości',
            newsNotFound: 'Nie udało się pobrać wpisu',
            noDataFromGif: 'Brak informacji z GIF-u',
            previousWeek: 'Poprzedni tydz.',
            registered: 'Zarejestrowane',
            registeredCount: 'Liczba zarejestrowanych',
         },
         educationalMaterialCategoryMap: {
            FOR_PATIENT: 'Dla pacjenta',
            FOR_SPECIALIST: 'Dla specjalisty',
         },
         educationalMaterialOpenError: 'Nie udało się otworzyć materiału. Spróbuj ponownie później.',
         fetchError: 'Nie udało się pobrać danych. Spróbuj ponownie później.',
         navigationItem: 'Start',
         neurologicalModule: {
            neurological: 'Neurologia',
         },
         psychiatricModule: {
            psychiatry: 'Psychiatria',
         },
         welcomeHeader: 'Witamy, {{title}} {{name}} {{surname}}',
         yourVisitsForToday: 'Twoje wizyty na dziś:',
      },
   },
};

export const dashboardTranslationKeys = createScopedTranslationKeys(translations.pl, 'dashboard');
